import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import {
  DEFAULT_GOOGLE_MAP_OPTIONS,
  DEFAULT_GOOGLE_STATIC_MAP_CONFIG,
  GOOGLE_MAPS_STATIC_MARKER,
  GoogleStaticMapConfig,
  RmaMapMarker,
} from '@rma/generic/maps/domain';
import { StaticGoogleMapComponent } from '@rma/public/maps/public/orc-static-google-map';
import { GoogleMapComponent } from '@rma/public/maps/public/ui-google-map';

@Component({
  selector: 'rma-market-report-comparable-properties-map',
  templateUrl: './market-report-comparable-properties-map.component.html',
  styleUrls: ['./market-report-comparable-properties-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [StaticGoogleMapComponent, GoogleMapComponent],
})
export class MarketReportComparablePropertiesMapComponent {
  @Input()
  isPrintMode: boolean | null = false;

  @Input()
  markers: RmaMapMarker[] | null = [];

  @Input()
  printedUrl: string | undefined;

  @Output()
  readonly markerSelected = new EventEmitter<string | string[]>();

  staticMapConfig: GoogleStaticMapConfig = {
    ...DEFAULT_GOOGLE_STATIC_MAP_CONFIG,
    height: 200,
    width: 640,
    scale: 2,
    clickToInteractive: false,
    markerParameterStyle: GOOGLE_MAPS_STATIC_MARKER,
    lazy: false,
    enableZoom: false,
  };

  interactiveMapOptions = {
    ...DEFAULT_GOOGLE_MAP_OPTIONS,
    disableDefaultUI: true,
  };
}
